import { motion } from 'framer-motion';
import React from 'react';
import ProfileImage from '../ui/ProfileImage';

// Map roles to badge color classes
function getRoleBadgeColor(role) {
  if (!role) return  "bg-emerald-950";
  const r = role.toLowerCase();

  switch (r) {
    case 'admin':
      return 'bg-blue-500';
    case 'supervisor':
      return 'bg-green-500';
    case 'guard':
      return 'bg-orange-500';
    case 'driver':
      return 'bg-purple-500';
    case 'employee':
      return 'bg-[#A9BD17]'; // ✅ Custom employee color
    default:
      return  'bg-emerald-950';
  }
}

const OrgChartNode = ({
  node,
  isSelected = false,
  onClick,
  className = "",
}) => {
  return (
    <motion.div
      className={`
        w-[320px] px-6 py-7 relative rounded-3xl
        shadow-[0px_15px_30px_0px_rgba(0,0,0,0.10)]
        shadow-[0px_5px_20px_0px_rgba(255,255,255,0.10)]
        shadow-[inset_0px_4px_25px_0px_rgba(255,255,255,0.35)]
        outline outline-1 outline-offset-[-1px] outline-neutral-300/20
        backdrop-blur-[30px] flex items-center gap-6 overflow-hidden cursor-pointer
        ${isSelected ? "border-2 border-green-700" : ""}
        ${className}
      `}
      style={{ background: "radial-gradient(ellipse 152.09% 184.58% at 136.24% -51.30%, rgba(10, 128, 137, 0.09) 0%, rgba(255,255,255,0.72) 100%)" }}
      initial={{ opacity: 0, y: 20, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.05 }}
      onClick={() => onClick?.(node)}
      data-node-id={node.id}
    >
    <ProfileImage
      userId={node.user_id}
      userName={node.name}
      imagePath={node.image_path && !node.image_path.startsWith('s3://') ? node.image_path : null}
      className="w-20 h-20 rounded-3xl outline outline-[3px] outline-green-700"
      size="xl"
      showLoading={false}
    />

      <div className="flex-1 h-12 flex flex-col justify-start items-start">
        <div className="text-black text-lg font-bold leading-snug">
          {node.name}
        </div>
        <div className="text-black text-lg font-normal leading-relaxed">
          ID : {node.id}
        </div>
      </div>
      {/* Role badge, top-right */}
      <div className={`px-6 py-3 top-0 right-0 absolute ${getRoleBadgeColor(node.role)} rounded-bl-xl rounded-br-xl inline-flex justify-center items-center gap-2.5 overflow-hidden`}>
  <div className="text-base font-semibold leading-tight" style={{ color: "#FFFFFF" }}>
    {node.role}
  </div>
</div>
    </motion.div>
  );
};

export default OrgChartNode;
